import { IllegalStateError } from "@archipad-js/core/error";

import { ReportGeneratedEntity } from "./generated/ReportGeneratedEntity";
import { ReportGenerationStatus } from "../lib/report";

export abstract class ReportEntity extends ReportGeneratedEntity {
    public get generationProgress(): number {
        const generationStatus = this.generationStatus;

        switch (generationStatus) {
            case null:
                return 0;
            case ReportGenerationStatus.generationStarted:
            case ReportGenerationStatus.dumpPatchCreated:
            case ReportGenerationStatus.tempAttachmentsCopied:
            case ReportGenerationStatus.attachmentsManifestUploaded:
            case ReportGenerationStatus.dumpPatchUploaded:
            case ReportGenerationStatus.reportConfigUploaded:
            case ReportGenerationStatus.appConfigUploaded:
            case ReportGenerationStatus.generationConfigUploaded:
            case ReportGenerationStatus.generationPending:
            case ReportGenerationStatus.generationProcessing:
                return 30;
            case ReportGenerationStatus.generationProcessed:
            case ReportGenerationStatus.adoptionStarted:
                return 60;
            case ReportGenerationStatus.outputAttachmentsManifestDownloaded:
            case ReportGenerationStatus.outputAttachmentDownloaded:
                return 90;
            case ReportGenerationStatus.generationDone:
                return 100;
            case ReportGenerationStatus.adoptingDone:
                return 0;
            default:
                throw new IllegalStateError(`Unsupported generationStatus "${generationStatus}"`);
        }
    }

    public get isGenerationRunning(): boolean {
        const generationStatus = this.generationStatus;

        switch (generationStatus) {
            case ReportGenerationStatus.generationPending:
            case ReportGenerationStatus.generationProcessing:
            case ReportGenerationStatus.generationProcessed:
            case ReportGenerationStatus.adoptionStarted:
            case ReportGenerationStatus.outputAttachmentsManifestDownloaded:
            case ReportGenerationStatus.outputAttachmentDownloaded:
            case ReportGenerationStatus.generationDone:
                return true;
            case ReportGenerationStatus.adoptingDone:
                return false;
        }

        return false;
    }
}
